import React from "react"

const Tooltip = ({value, children}) => {
  return(
    <span className="tooltip" data-tip={value}>{children}</span>
  )
}

export default Tooltip